export class DialogConfig<D = any> {
  // aria-labelledby is recommended by W3, but it is not working in Chrome with Voice Over
  // use aria-label for now until aria-labelledby works in Chrome with Voice Over
  ariaLabel?: string;
  data?: D;
  id: string; // Dialog ID
  screenMode: DialogScreenMode;
  keepModalOnRouteChange?: boolean;
  keepModalOnOverlayClick?: boolean;
  keepModalOnEscapeKey?: boolean;
}

export type DialogScreenMode =
  | 'fullscreen'
  | 'center-md'
  | 'center-ml'
  | 'center-lg';
